<template>
  <div class="tabMedicine tab">
    <div
      class="items"
      v-for="(item, i) in Items"
      :key="item.name"
      v-show="vaccineStatus === 'Unlocked'"
    >
      <ProdItem
        :medicine="true"
        :name="item.name"
        :index="i"
        :level="item.level"
        :price="item.price"
        :time="item.time"
        :icon="item.icon"
        :on="item.enabled"
      />
    </div>
  </div>
</template>

<script>
import ProdItem from "@/components/ProdItem.vue";

export default {
  name: "Production",
  components: { ProdItem },
  props: {},

  computed: {
    Items: function() {
      return this.$store.state.medItems;
    },

    vaccineStatus: function() {
      return this.$store.state.vaccineStatus;
    },

    lockDown: function() {
      return this.$store.state.lockdown;
    },
  },

  data() {
    return {};
  },

  mounted: function() {
    if (this.$store.getters.medItemsCount < 1) {
      this.$store.dispatch("loadMedItem", 0);
      this.$store.dispatch("loadMedItem", 1);
    }

    this.track("TAB MEDICINE", "TAB MEDICINE");
  },

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.tabMedicine {
  .opening {
    margin-top: 40px;
    background: #fff;
    border-radius: 24px;
    padding: 16px;
    text-align: center;

    h2 {
      margin-bottom: 0;
    }

    p {
      line-height: 1.5;
    }
  }
}
</style>
